import { company_name } from "@/i18n/variables";

const password_vault = {
	add_button: "Wachtwoord delen",
	description: {
		href: "https://support.tuxis.nl/nl/knowledgebase/article/wachtwoord-makkelijk-onthouden",
		text: `${company_name}, of een andere gebruiker binnen uw organisatie, heeft de onderstaande wachtwoorden met u gedeeld ter inzage. <strong>Deze zijn 30 dagen zichtbaar</strong>. Het wijzigen van een wachtwoord is niet van invloed op de dienst. Jij kunt hier ook wachtwoorden met ${company_name} en andere gebruikers delen. Wil je voorkomen dat je ooit je wachtwoorden kwijtraakt? Lees dan <a>dit artikel</a>.`,
	},
	dialog_add: {
		description: "",
		title: "Gedeelde inloggegevens",
	},
	dialog_delete: {
		description: "Weet je zeker dat je <strong>{{name}}</strong> wilt verwijderen?",
		title: "Wachtwoord verwijderen",
	},
	dialog_update: {
		confirmation: {
			description:
				"Let op! De wijzigingen die u hier aanbrengt hebben geen invloed op de inloggegevens van de gekoppelde producten/diensten.",
			title: "Gedeeld wachtwoord bijwerken",
		},
	},
	generate: "Genereren",
	password_text:
		"Het wachtwoord is niet gekoppeld aan een dienst. Dit wachtwoord is gedeeld met u. Sla het op in uw wachtwoordmanager.",

	status: {
		create_success: "Wachtwoord succesvol gedeeld!",
		delete_success: "Wachtwoord succesvol verwijderd!",
		successful_copy_otp_secret: "2FA secret gekopieerd naar klembord",
		successful_copy_password: "Wachtwoord gekopieerd naar klembord",
		successful_copy_url: "Hostname/url gekopieerd naar klembord",
		successful_copy_username: "Inlognaam gekopieerd naar klembord",
		update_success: "Wachtwoord succesvol gewijzigd!",
	},
	table: {
		actions: "Acties",
		description: "Omschrijving",
		expires_at: "Zichtbaar tot",
		name: "Naam",
		not_visible: "Niet zichtbaar",
		otp_secret: "2FA secret",
		password: "Wachtwoord",
		support_has_access: `${company_name} mag wachtwoord inzien`,
		url: "Hostname/url",
		user_list: "Zichtbaar voor",
		username: "Inlognaam",
	},
	title: "Gedeelde wachtwoorden",
};

export default password_vault;
